// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// const ChatbaseWidget = () => {
//   const location = useLocation();

//   useEffect(() => {
//     const excludedRoutes = [
//       "/join-us",
//       "/contractor-application",
//       "/service-detail/routine-clean",
//       "/service-detail/move-out-move-in-clean",
//       "/service-detail/deep-cleaning",
//       "/service-detail/post-event-cleanup",
//       "/help-and-legal/terms-and-conditions"
//     ];
//     const isExcluded = excludedRoutes.includes(location.pathname);
//     const scriptId = "ysqXXYIZ1WXJRElLqvFFP";

//     const removeChatbase = () => {
//       try {
//         document.getElementById(scriptId)?.remove();
//         document.getElementById("chatbase-bubble-button")?.remove();
//         document.getElementById("chatbase-message-bubbles")?.remove();
//         document.getElementById("chatbase-bubble-window")?.remove();
//         document.querySelector("iframe[src*='chatbase']")?.remove();
//         delete window.chatbase;
//         // console.log("Chatbase removed");
//       } catch (err) {
//         // console.error("Error during Chatbase cleanup:", err);
//       }
//     };

//     const loadChatbase = () => {
//       if (!document.getElementById(scriptId)) {
//         const script = document.createElement("script");
//         script.src = "https://www.chatbase.co/embed.min.js";
//         script.id = scriptId;
//         script.defer = true;

//         script.onload = () => {

//           setTimeout(() => {
//             const iframe = document.querySelector("iframe[src*='chatbase']");
//             if (iframe) {
//               // console.log("Chatbase iframe is present");
//             } else {
//               // console.warn("Chatbase iframe NOT found");
//             }
//           }, 500);
//         };

//         script.onerror = () => {
//           // console.error("Failed to load Chatbase script");
//         };

//         document.body.appendChild(script);
//       } else {
//         // console.log("Chatbase script already exists, skipping load.");
//       }
//     };

//     if (isExcluded) {
//       removeChatbase();
//     } else {
//       loadChatbase();
//     }

//     return () => {
//       if (isExcluded) {
//         removeChatbase();
//       }
//     };
//   }, [location]);

//   return null;
// };

// export default ChatbaseWidget;

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ChatbaseWidget = () => {
  const location = useLocation();

  useEffect(() => {
    // Business hours (in 24h PST)
    const hours = {
      0: { start: 5, end: 19 }, // Sunday: 5am - 7pm
      1: { start: 5, end: 19 }, // Monday: 5am - 7pm
      2: { start: 7, end: 19 }, // Tuesday: 7am - 7pm
      3: { start: 7, end: 19 }, // Wednesday: 7am - 7pm
      4: { start: 5, end: 17 }, // Thursday: 5am - 5pm
      5: { start: 5, end: 17 }, // Friday: 5am - 5pm
      6: { start: 5, end: 19 }, // Saturday: 5am - 7pm
    };

    const excludedRoutes = [
      "/join-us",
      "/contractor-application",
      "/service-detail/routine-clean",
      "/service-detail/move-out-move-in-clean",
      "/service-detail/deep-cleaning",
      "/service-detail/post-event-cleanup",
      "/help-and-legal/terms-and-conditions",
    ];
    const isExcluded = excludedRoutes.includes(location.pathname);

    // Get current PST time
    const now = new Date();
    const nowPST = new Date(
      now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );
    const currentDay = nowPST.getDay();
    const currentHour = nowPST.getHours();
    const { start, end } = hours[currentDay];

    const inBusinessHours = currentHour >= start && currentHour < end;

    // IDs
    const chatbaseScriptId = "ysqXXYIZ1WXJRElLqvFFP";
    const tawkScriptId = "tawkScript";

    const removeChatbase = () => {
      document.getElementById(chatbaseScriptId)?.remove();
      document.getElementById("chatbase-bubble-button")?.remove();
      document.getElementById("chatbase-message-bubbles")?.remove();
      document.getElementById("chatbase-bubble-window")?.remove();
      document.querySelector("iframe[src*='chatbase']")?.remove();
      delete window.chatbase;
    };

    const removeTawk = () => {
      document.getElementById(tawkScriptId)?.remove();
      document.querySelector("iframe[src*='tawk']")?.remove();
      delete window.Tawk_API;
    };

    const loadTawk = () => {
      if (!document.getElementById(tawkScriptId)) {
        const script = document.createElement("script");
        script.id = tawkScriptId;
        script.async = true;
        script.src = "https://embed.tawk.to/6911aa18ee2732195b2fc4a8/1j9mg0s2k";
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");
        document.body.appendChild(script);
      }
    };

    const loadChatbase = () => {
      if (!document.getElementById(chatbaseScriptId)) {
        const script = document.createElement("script");
        script.src = "https://www.chatbase.co/embed.min.js";
        script.id = chatbaseScriptId;
        script.defer = true;
        document.body.appendChild(script);
      }
    };

    // Logic
    if (!isExcluded) {
      if (inBusinessHours) {
        // Show Tawk.to during business hours
        removeChatbase();
        loadTawk();
        // console.log("Tawk.to loaded (Business hours PST)");
      } else {
        // Show Chatbase during off-hours
        removeTawk();
        loadChatbase();
        // console.log("Chatbase loaded (Off-hours PST)");
      }
    } else {
      removeTawk();
      removeChatbase();
    }

    // Cleanup on route change
    return () => {
      if (isExcluded) {
        removeTawk();
        removeChatbase();
      }
    };
  }, [location]);

  return null;
};

export default ChatbaseWidget;
